module.exports = __webpack_public_path__ + "media/npc_dota_hero_lich.76f1b090.webm";